import { atom } from 'jotai';
import { SelectItem } from '../../../types';

export const securitiesFundFilterState = atom<SelectItem[] | null>(null);

export const securitiesRealizedFilterState = atom<SelectItem[] | null>(null);
